// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2RL3P","search":"Settings_search__1092A","filter":"Settings_filter__1RkLK"};